import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { COMPANY } from "@/data/site";

const navItems = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/services", label: "Services", testid: "nav-services" },
  { to: "/industries", label: "Industries", testid: "nav-industries" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#050912]/85 border-b border-slate-800/80"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-36 flex items-center gap-8 md:gap-12 justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group shrink-0">
          <img
            src={COMPANY.logoUrl}
            alt="bekTech — Network & Cybersecurity Consulting"
            className="h-32 w-auto object-contain group-hover:opacity-90 transition-opacity"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-7 lg:gap-9 shrink-0">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-white" : "text-slate-400 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/contact"
            data-testid="nav-cta-request-consultation"
            className="bek-cta"
          >
            Request Consultation
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-slate-200"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-slate-800 bg-[#050912]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`${item.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-white" : "text-slate-400"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-cta-request-consultation-mobile"
              className="bek-cta justify-center"
            >
              Request Consultation
            </Link>
            <div className="pt-3 mt-1 border-t border-slate-800 text-sm text-slate-400 font-mono-tech">
              <div>{COMPANY.phone}</div>
              <div className="truncate">{COMPANY.email}</div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
